// extracted by mini-css-extract-plugin
export default {"dialogActions":"attributeSelectionDialog_dialogActions__+nXqy"};